import PropTypes from "prop-types";

// The small PRESS / PUSH / PULL / PERFORM tag next to the title of the automation modals
const ProductChip = ({ product }) => (
  <span className="ea-product-chip">{product.toUpperCase()}</span>
);

ProductChip.propTypes = { product: PropTypes.string.isRequired };

export default ProductChip;
